export const initialState = {
    id: '',
    name: '',
    newImage: null,
};

export const templatesPath = '/templates';

export const breadCrumbTrail = [
    { label: 'Admin', path: '' },
    { label: 'Templates', path: templatesPath },
    { label: 'Add Template', path: '' },
];

export const breadCrumbTrailEdit = [
    { label: 'Admin', path: '' },
    { label: 'Templates', path: templatesPath },
    { label: 'Edit Template', path: '' },
];

export const addHeader = 'Template Details';
export const editHeader = 'Edit Template Details';
